<template>
    <Transition name="pop">
        <div id="invitePop" class="pop" v-if="state.show">
            <div class="content">
                <span class="close" @click="state.show = false"></span>
                <div class="header"></div>
                <div class="middle"></div>
                <div class="footer"></div>
                <h1>兄弟团邀请分享</h1>
                <div class="text">
                     {{ state.text }}<br />
                    链接地址：https://actxyx.web.sdo.com/project/2026/0902_Join/index.html
                    <br />邀请码：<strong>{{ user.cur_team_id }}</strong>
                </div>
                <div
                    class="btn-confirm"
                    :data-clipboard-text="`${state.text}链接地址：https://actxyx.web.sdo.com/project/2026/0902_Join/index.html 邀请码：${user.cur_team_id}`"
                >
                    复制分享
                </div>
            </div>
        </div>
    </Transition>
</template>

<script setup>
import { storeToRefs } from "pinia";
import ClipboardJS from "clipboard";
import { reactive, onMounted } from "vue";
import useStore from "@/store/store";
const { user } = storeToRefs(useStore());

const state = reactive({
    show: false,
    text: ` 《新英雄年代》畅享版新服“乘风破浪-先驱”9月11日盛大开启！复制下方“邀请码”，进入活动链接填写，与我组团一同瓜分海量豪礼，超多精美周边等你来拿！`
});

onMounted(() => {
    const clipboard = new ClipboardJS("#invitePop .btn-confirm");
    clipboard.on("success", function (e) {
        CsGame.alert("邀请链接已成功复制！", 1200, "success");
    });
});

defineExpose({
    Show: () => {
        state.show = true;
    }
});
</script>

<style lang="scss" scoped>
#invitePop {
    .content {
        .text {
            margin-bottom: 20px;
            line-height: 1.6;
            word-break: break-all;
            strong {
                color: #42906a;
                font-weight: bold;
            }
        }
        .btn-confirm {
            width: 240px;
            height: 50px;
            margin: 0px auto 10px auto;
            text-align: center;
            line-height: 50px;
            cursor: pointer;
            color: #fff;
            font-size: 20px;
            border-radius: 6px;
            background: linear-gradient(to bottom, #86362c, #d6584b);
        }
    }
}
</style>
